import { useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        document.documentElement.scrollTo({
            behavior: 'instant',
            top: 0
        });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
